module.exports = __webpack_public_path__ + "media/images/step4-55ba53013a871f386ef944ce1c1d1add.png";